import { APP_STATUS_ERROR } from '../../../constants/common'
import { usePageBrowserTabTitle } from '../../../hooks'

import * as styles from './ErrorPageInit.module.css'

function ErrorPageInit() {
  usePageBrowserTabTitle({ errorStatus: APP_STATUS_ERROR })

  return (
    <div className={styles.ErrorPageInit}>
      <div className={styles.message}>
        <h1 className={styles.title}>We apologize for inconveniences!</h1>

        <span className={styles.separator} />

        <p className={styles.text}>The system is being updated now.</p>
        <p className={styles.text}>We will come back soon online!</p>
      </div>
    </div>
  )
}

export default ErrorPageInit
